// extracted by mini-css-extract-plugin
export var wrapper = "NotFound-module--wrapper--RHmco";
export var text = "NotFound-module--text--39Idq";
export var firstLine = "NotFound-module--firstLine--2wNMN";
export var secondLine = "NotFound-module--secondLine--104IF";